import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, LogOut, Calendar, Plus, Trash2, ToggleLeft, ToggleRight, ChevronDown, ChevronUp, Mountain, IndianRupee, Save, Bell, Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { useApp } from '../context/AppContext';
import { supabase } from "../lib/supabase";
const SUPABASE_URL = "https://gthnqxdkfjvikhprrise.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd0aG5xeGRrZmp2aWtocHJyaXNlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcwMTA1NTgsImV4cCI6MjA4MjU4NjU1OH0.PkK4HfrfKWigU98-7Y73W8gV5nRkfziDafCDB8genfg";



const StaffDashboard = () => {
  const navigate = useNavigate();
  const { 
  tours, 
  bookings,
  isStaffLoggedIn, 
  loginStaff, 
  logoutStaff,
  updateTourPrice 
} = useApp();


  
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [expandedTour, setExpandedTour] = useState(null);
  const [newDate, setNewDate] = useState({ startDate: '', endDate: '' });
  const [editingPrice, setEditingPrice] = useState(null);
  const [priceForm, setPriceForm] = useState({ price: 0, originalPrice: 0 });
  const [activeTab, setActiveTab] = useState('availability');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { availability, fetchAvailability } = useApp();


  const handleLogin = (e) => {
    e.preventDefault();
    if (loginStaff(password)) {
      setLoginError('');
    } else {
      setLoginError('Invalid password');
    }
  };

const handleAddDate = async (tourId) => {
  if (!newDate.startDate || !newDate.endDate) return;

  const { error } = await supabase
    .from("activitydates")
    .insert({
      tour_id: tourId,
      start_date: newDate.startDate,
      end_date: newDate.endDate,
      status: "open",
    });

  if (error) {
    console.error("Add date error:", error.message);
    alert("Failed to add date");
    return;
  }

  await fetchAvailability(); // ✅ THIS is what you were missing
  setNewDate({ startDate: "", endDate: "" });
};


const removeTourDate = async (tourId, dateId) => {
  const { error } = await supabase
    .from("activitydates")
    .delete()
    .eq("id", dateId);

  if (error) {
    console.error("Delete error:", error);
    alert("Failed to delete date");
    return;
  }

  await fetchAvailability(); // ✅ REQUIRED
};



  const handleEditPrice = (tour) => {
    setEditingPrice(tour.id);
    setPriceForm({ price: tour.price, originalPrice: tour.originalPrice });
  };

  const handleSavePrice = (tourId) => {
    if (priceForm.price <= 0) {
      alert('Price must be greater than 0');
      return;
    }
    updateTourPrice(tourId, priceForm.price, priceForm.originalPrice);
    setEditingPrice(null);
  };



const toggleAvailability = async (tourId, dateId) => {
  const date = availability[tourId]?.find(d => d.id === dateId);
  if (!date) return;

  const newStatus = date.isOpen ? "closed" : "open";

  const { error } = await supabase
    .from("activitydates")
    .update({ status: newStatus })
    .eq("id", dateId);

  if (error) {
    console.error(error.message);
    return;
  }

  await fetchAvailability(); // ✅ REQUIRED
};


  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  // Login Screen
  if (!isStaffLoggedIn) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-emerald-800 to-teal-900 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl p-6 sm:p-8 w-full max-w-md shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Mountain className="h-8 w-8 text-emerald-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Staff Dashboard</h1>
            <p className="text-gray-500 mt-2">Magic Mountain Adventures</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Staff Password</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none"
                  placeholder="Enter password"
                />
              </div>
              {loginError && <p className="text-red-500 text-sm mt-2">{loginError}</p>}
            </div>

            <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700 py-6 text-lg rounded-xl">Login</Button>

            <button type="button" onClick={() => navigate('/')} className="w-full text-center text-gray-500 hover:text-gray-700">
              Back to Website
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Dashboard
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="p-1.5 sm:p-2 bg-emerald-100 rounded-lg sm:rounded-xl">
                <Mountain className="h-5 w-5 sm:h-6 sm:w-6 text-emerald-600" />
              </div>
              <div>
                <h1 className="font-bold text-gray-900 text-sm sm:text-base">Staff Dashboard</h1>
                <p className="text-xs sm:text-sm text-gray-500 hidden sm:block">Manage tours & availability</p>
              </div>
            </div>
            
            {/* Desktop Actions */}
            <div className="hidden sm:flex items-center gap-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-emerald-600 text-sm font-medium">
                View Website
              </button>
              <Button onClick={logoutStaff} variant="outline" className="border-red-200 text-red-600 hover:bg-red-50">
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="sm:hidden p-2 rounded-lg hover:bg-gray-100">
              {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="sm:hidden mt-3 pt-3 border-t border-gray-100 space-y-2">
              <button onClick={() => { navigate('/'); setMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2 text-gray-600 hover:bg-gray-100 rounded-lg text-sm">
                View Website
              </button>
              <button onClick={logoutStaff} className="block w-full text-left px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg text-sm">
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6">
        <div className="flex gap-1 sm:gap-2 border-b border-gray-200 overflow-x-auto">
          <button
            onClick={() => setActiveTab('availability')}
            className={`px-3 sm:px-6 py-2 sm:py-3 font-medium text-xs sm:text-sm border-b-2 transition-colors whitespace-nowrap ${
              activeTab === 'availability' ? 'border-emerald-600 text-emerald-600' : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Calendar className="h-4 w-4 inline mr-1 sm:mr-2" />
            <span className="hidden xs:inline">Tour</span> Availability
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        {activeTab === 'availability' ? (
          <>
            <div className="mb-4 sm:mb-8">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">Tour Management</h2>
              <p className="text-gray-600 text-sm sm:text-base">Manage prices, dates, and availability.</p>
            </div>

            {/* Tour List */}
            <div className="space-y-3 sm:space-y-4">
              {tours.map((tour) => {
                const tourDates = availability[tour.id] || [];
                const isExpanded = expandedTour === tour.id;
                return (
                  <div key={tour.id} className="bg-white rounded-xl sm:rounded-2xl shadow-sm overflow-hidden">
                    {/* Tour Header - Mobile Friendly */}
                    <div className="p-3 sm:p-6 border-b border-gray-100">
                      <div className="flex items-start sm:items-center gap-3 sm:gap-4">
                        <img src={tour.coverImage} alt={tour.name} className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl object-cover flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-gray-900 text-sm sm:text-base truncate">{tour.name}</h3>
                          <p className="text-xs sm:text-sm text-gray-500">{tour.duration}</p>
                          
                          {/* Mobile Price Display */}
                          <div className="mt-2 sm:hidden">
                            {editingPrice === tour.id ? (
                              <div className="flex flex-wrap gap-2 items-center">
                                <input
                                  type="number"
                                  value={priceForm.price}
                                  onChange={(e) => setPriceForm({ ...priceForm, price: parseInt(e.target.value) || 0 })}
                                  className="w-24 px-2 py-1 rounded-lg border border-gray-200 text-sm"
                                  placeholder="Price"
                                />
                                <Button size="sm" onClick={() => handleSavePrice(tour.id)} className="bg-emerald-600 hover:bg-emerald-700 h-8">
                                  <Save className="h-3 w-3" />
                                </Button>
                                <Button size="sm" variant="outline" onClick={() => setEditingPrice(null)} className="h-8">
                                  Cancel
                                </Button>
                              </div>
                            ) : (
                              <div className="flex items-center gap-2">
                              </div>
                            )}
                          </div>
                        </div>
                        
                        {/* Desktop Price & Actions */}
                        <div className="hidden sm:flex items-center gap-4">
                          {editingPrice === tour.id ? (
                            <div className="flex items-center gap-2">
                              <div className="flex items-center gap-1">
                                <span className="text-xs text-gray-500">Price:</span>
                                <input
                                  type="number"
                                  value={priceForm.price}
                                  onChange={(e) => setPriceForm({ ...priceForm, price: parseInt(e.target.value) || 0 })}
                                  className="w-24 px-2 py-1 rounded-lg border border-gray-200 text-sm"
                                />
                              </div>
                              <Button size="sm" onClick={() => handleSavePrice(tour.id)} className="bg-emerald-600 hover:bg-emerald-700">
                                <Save className="h-4 w-4" />
                              </Button>
                              <Button size="sm" variant="outline" onClick={() => setEditingPrice(null)}>Cancel</Button>
                            </div>
                          ) : (
                            <div> </div>
                          )}
                          
                          <Badge className={tourDates.filter(d => d.isOpen).length > 0 ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}>
                            {tourDates.filter(d => d.isOpen).length} Open
                          </Badge>
                        </div>
                        
                        {/* Expand Button */}
                        <button onClick={() => setExpandedTour(isExpanded ? null : tour.id)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0">
                          {isExpanded ? <ChevronUp className="h-5 w-5 text-gray-400" /> : <ChevronDown className="h-5 w-5 text-gray-400" />}
                        </button>
                      </div>

                      {/* Mobile Badge */}
                      <div className="sm:hidden mt-3 flex gap-2">
                        <Badge className={tourDates.filter(d => d.isOpen).length > 0 ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}>
                          {tourDates.filter(d => d.isOpen).length} Open Date(s)
                        </Badge>
                      </div>
                    </div>

                    {/* Expanded Content */}
                    {isExpanded && (
                      <div className="p-3 sm:px-6 sm:pb-6">
                        {/* Add New Date */}
                        <div className="mt-3 sm:mt-6 p-3 sm:p-4 bg-gray-50 rounded-lg sm:rounded-xl">
                          <h4 className="font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2 text-sm sm:text-base">
                            <Calendar className="h-4 w-4 sm:h-5 sm:w-5 text-emerald-600" />
                            Add New Date Range
                          </h4>
                          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-end">
                            <div className="flex-1">
                              <label className="block text-xs sm:text-sm text-gray-600 mb-1">Start Date</label>
                              <input
                                type="date"
                                value={newDate.startDate}
                                onChange={(e) => setNewDate({ ...newDate, startDate: e.target.value })}
                                className="w-full px-3 sm:px-4 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none text-sm"
                              />
                            </div>
                            <div className="flex-1">
                              <label className="block text-xs sm:text-sm text-gray-600 mb-1">End Date</label>
                              <input
                                type="date"
                                value={newDate.endDate}
                                onChange={(e) => setNewDate({ ...newDate, endDate: e.target.value })}
                                className="w-full px-3 sm:px-4 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none text-sm"
                              />
                            </div>
                            <Button onClick={() => handleAddDate(tour.id)} className="bg-emerald-600 hover:bg-emerald-700 w-full sm:w-auto">
                              <Plus className="h-4 w-4 mr-2" />
                              Add Date
                            </Button>
                          </div>
                        </div>

                        {/* Date List */}
                        <div className="mt-4 sm:mt-6">
                          <h4 className="font-semibold text-gray-900 mb-3 sm:mb-4 text-sm sm:text-base">Scheduled Dates</h4>
                          {tourDates.length === 0 ? (
                            <p className="text-gray-500 text-center py-6 sm:py-8 bg-gray-50 rounded-lg sm:rounded-xl text-sm">
                              No dates scheduled yet.
                            </p>
                          ) : (
                            <div className="space-y-2 sm:space-y-3">
                              {tourDates.map((date) => (
                                <div
                                  key={date.id}
                                  className={`flex flex-col sm:flex-row sm:items-center justify-between p-3 sm:p-4 rounded-lg sm:rounded-xl border-2 transition-all gap-3 ${
                                    date.isOpen ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'
                                  }`}
                                >
                                  <div className="flex items-center gap-3">
                                    <Calendar className={`h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 ${date.isOpen ? 'text-green-600' : 'text-red-600'}`} />
                                    <div>
                                      <p className="font-medium text-gray-900 text-sm sm:text-base">
                                        {formatDate(date.startDate)} - {formatDate(date.endDate)}
                                      </p>
                                      <Badge className={`mt-1 text-xs ${date.isOpen ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                        {date.isOpen ? 'Open' : 'Closed'}
                                      </Badge>
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2 ml-7 sm:ml-0">
                                    <button
                                      onClick={() => toggleAvailability(tour.id, date.id)}
                                      className={`p-2 rounded-lg transition-colors ${
                                        date.isOpen ? 'bg-green-100 text-green-700 hover:bg-green-200' : 'bg-red-100 text-red-700 hover:bg-red-200'
                                      }`}
                                      title={date.isOpen ? 'Close' : 'Open'}
                                    >
                                      {date.isOpen ? <ToggleRight className="h-5 w-5" /> : <ToggleLeft className="h-5 w-5" />}
                                    </button>
                                    <button
                                      onClick={() => removeTourDate(tour.id, date.id)}
                                      className="p-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-red-100 hover:text-red-600 transition-colors"
                                      title="Delete"
                                    >
                                      <Trash2 className="h-5 w-5" />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <>
            <div className="mb-4 sm:mb-8">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2">Recent Bookings</h2>
              <p className="text-gray-600 text-sm sm:text-base">View all confirmed bookings.</p>
            </div>

            {bookings.length === 0 ? (
              <div className="bg-white rounded-xl sm:rounded-2xl p-8 sm:p-12 text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Bell className="h-6 w-6 sm:h-8 sm:w-8 text-gray-400" />
                </div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">No Bookings Yet</h3>
                <p className="text-gray-500 text-sm">Booking requests will appear here.</p>
              </div>
            ) : (
              <div className="space-y-3 sm:space-y-4">
                {bookings.map((booking) => (
                  <div key={booking.id} className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                      <div className="flex-1">
                        <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-2">
                          <h3 className="font-bold text-gray-900 text-sm sm:text-base">{booking.tourName}</h3>
                          <Badge className="bg-emerald-100 text-emerald-700 text-xs">{booking.status}</Badge>
                        </div>
                        <p className="text-xs sm:text-sm text-gray-500 mb-3 sm:mb-4">
                          #{booking.id} • {new Date(booking.createdAt).toLocaleString()}
                        </p>
                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                          <div>
                            <p className="text-xs text-gray-500 uppercase mb-1">Customer</p>
                            <p className="font-medium text-sm">{booking.name}</p>
                            <p className="text-xs sm:text-sm text-gray-600">{booking.phone}</p>
                            {booking.email && <p className="text-xs sm:text-sm text-gray-600 truncate">{booking.email}</p>}
                          </div>
                          <div>
                            <p className="text-xs text-gray-500 uppercase mb-1">Booking Details</p>
                            {booking.selectedDate ? (
                              <p className="font-medium text-sm">
                                {formatDate(booking.selectedDate.startDate)} - {formatDate(booking.selectedDate.endDate)}
                              </p>
                            ) : (
                              <p className="font-medium text-amber-600 text-sm">Flexible Date</p>
                            )}
                            <p className="text-xs sm:text-sm text-gray-600">{booking.guests} Guest(s) • {booking.paymentMethod.toUpperCase()}</p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="text-right sm:text-right">
                        <p className="text-xl sm:text-2xl font-bold text-emerald-600">
                          ₹{booking.totalAmount.toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StaffDashboard;
